var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    width: 24,
    height: 24,
    d: "M0.50 19.90L4.80 3.09L7.20 3.09L11.50 19.90L9.41 19.90L8.13 14.41L3.87 14.41L2.59 19.90L0.50 19.90ZM7.75 12.74L6 4.79L4.24 12.74L7.75 12.74ZM13.68 19.90L13.68 3.09L17.88 3.09Q19.96 3.09 21.25 4.05L21.25 4.05Q22.95 5.37 22.95 7.83L22.95 7.83Q22.95 10.79 20.54 12.08L20.54 12.08Q19.41 12.70 17.93 12.70L17.93 12.70L15.60 12.70L15.60 19.90L13.68 19.90ZM17.73 4.92L15.60 4.92L15.60 10.88L17.73 10.88Q20.98 10.88 20.98 7.85L20.98 7.85Q20.98 6.08 19.54 5.33L19.54 5.33Q18.76 4.92 17.73 4.92L17.73 4.92ZM33.43 4.88L31.03 4.88L31.03 18.12L33.43 18.12L33.43 19.90L26.57 19.90L26.57 18.12L28.97 18.12L28.97 4.88L26.57 4.88L26.57 3.09L33.43 3.09L33.43 4.88Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiLogo);
export default __webpack_public_path__ + "static/media/api-logo.b074a084d3d698002abbf69eebdb415c.svg";
export { ForwardRef as ReactComponent };